import { jsx, jsxs } from "react/jsx-runtime";
import { MediaObject, Text, Icon } from "@zillow/constellation-10";
import { IconClockOutline } from "@zillow/constellation-icons/react/outline/icon-clock-outline";
import PropTypes from "prop-types";
import "react";
import { getReadTimeWithDefault } from "../../utils/getReadTimeWithDefault.esm.js";
const PostReadTime = ({
  readTime
}) => /* @__PURE__ */ jsx(MediaObject, { css: {
  alignItems: "center",
  gap: "tightest"
}, media: /* @__PURE__ */ jsx(Icon, { render: /* @__PURE__ */ jsx(IconClockOutline, {}), size: "sm", css: {
  color: "text.subtle"
} }), children: /* @__PURE__ */ jsxs(Text, { textStyle: "body-sm", css: {
  color: "text.subtle"
}, children: [
  getReadTimeWithDefault(readTime),
  " min read"
] }) });
PostReadTime.propTypes = {
  readTime: PropTypes.number
};
export {
  PostReadTime as default
};
